import React from 'react';

import NewsCards from '~/Components/NewsCards';
// import ArticleCards from '~/Components/ArticleCards';
import Footer from '~/Components/Footer';
import { Title } from './styles';
import Alerts from '~/Components/Alert';
import ServicosPrefeitura from './ServicosPrefeitura';

const Home = () => {
	return (
		<>
		{
			 localStorage.getItem('termgeo')!=='true'? 
			 <Alerts color={'info'}
			 title={'Termo de Uso de dados Geoespaciais'}
			 textBody={'Aceite sobre os termos de uso de dados geoespaciais.'}
			 />
			 : ''			
			}
			<Title>
				<h1>SEJA BEM VINDO</h1>
				<p>
					O Geoportal é uma plataforma do Sistema de Gestão Territorial e permite
					acesso à Infraestrutura de Dados Espaciais – IDE da
					Prefeitura de Divinópolis.
				</p>
				<p>
					Aqui você encontra a emissão de documentos automatizados,
					geoserviços, dados para download, metadados, tutorial de
					uso, documentação técnica, notícias, entre outras
					funcionalidades.
				</p>
			</Title>
			<br />
			<NewsCards />
			<br />
			<br />
			<br />
			{/* <ArticleCards /> */}
			<ServicosPrefeitura/>
			<Footer />
			
		</>
	);
};

export default Home;
